import type { TCPOffsetOption } from '@sb/motion-planning';

import type { DeviceConfiguration } from '../types';

import { getTooltipOptions } from './getTooltipOptions';

/**
 * The tooltip option to treat as a device's default Active Tooltip when no
 * option was explicitly chosen: the first tooltip the device defines.
 *
 * Only occupied tooltips are eligible -- see `getTooltipOptions`, which owns
 * the per-kind rules -- so a device with nothing to offer defaults to nothing
 * rather than to an option that would silently resolve to the flange.
 *
 * Returns `undefined` silently. Callers also use this as a membership test
 * ("does this device offer any tooltip?"), including validation that reruns
 * on every routine edit, so a log here would be noise rather than signal --
 * the caller that actually needed a tooltip is the one that can say so.
 */
export function getDefaultTooltipOption(
  config: DeviceConfiguration,
): TCPOffsetOption | undefined {
  const [firstOption] = getTooltipOptions(config);

  return firstOption?.tcpOption;
}
